import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { values, get } from "lodash"

import { texts, prendasHombre, prendasMujer, prices } from "./laundry.js"
import { printMoney } from "../../../lib/Tools.js";

const lang = "ch"

function getText(k) {
  return get(texts, [k, lang], `[${k}][${lang}]`)
}

function getPrice(k, mode, makeItPretty) {
  if (makeItPretty) {
    const num = prices[k][mode]
    if (num) {
      return `${printMoney(num)}€`
    }
    else {
      return "No disponible"
    }
  }
  else return prices[k][mode] || 0
}

class LaundryItem extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      tab: "m",
      selectionNumber: {},
      selectionKind: {},
    }
  }
  
  render() {
    return (
      <div className="item">
        <div>
          <div className="titles">
            <h1>{this.props.text.ch}</h1>
            <h2>{this.props.text.es}</h2>
          </div>
          <div className="counter">
            <button 
              className={!this.props.number ? "minus disabled" : "minus"}
              onClick={() => this.props.onSum(-1)}
            >
              {"–"}
            </button>
            <p>{this.props.number || 0}</p>
            <button 
              className="plus"
              onClick={() => this.props.onSum(+1)}
            >
              {"+"}
            </button>
          </div>
        </div>
        {
          !!this.props.number && (
            <div className="kinds">
              <button 
                className={this.props.kind == 1 ? "on" : "off"}
                onClick={() => this.props.onKindChange(1)}
                disabled={!getPrice(this.props.itemKey, "lavadoplan")}
              >
                <p>{getText("lavadoplan")}</p>
                <p>{getPrice(this.props.itemKey, "lavadoplan", true)}</p>
              </button>
              <button 
                className={this.props.kind == 2 ? "on" : "off"}
                onClick={() => this.props.onKindChange(2)}
                disabled={!getPrice(this.props.itemKey, "planchar")}
              >
                <p>{getText("planchar")}</p>
                <p>{getPrice(this.props.itemKey, "planchar", true)}</p>
              </button>
              <button 
                className={this.props.kind == 3 ? "on" : "off"}
                onClick={() => this.props.onKindChange(3)}
                disabled={!getPrice(this.props.itemKey, "lavadosec")}
              >
                <p>{getText("lavadosec")}</p>
                <p>{getPrice(this.props.itemKey, "lavadosec", true)}</p>
              </button>
            </div>
          )
        }
      </div>
    )
  }
}

LaundryItem.propTypes = {
  onKindChange: PropTypes.func.isRequired,
  onSum: PropTypes.func.isRequired,
  itemKey: PropTypes.string.isRequired,
  kind: PropTypes.number.isRequired,
  number: PropTypes.number.isRequired,
  text: PropTypes.shape({
    es: PropTypes.string,
    ch: PropTypes.string,
  }).isRequired
}

export default LaundryItem




// WEBPACK FOOTER //
// ./src/app/catalogo/hotels/Laundry.Item.jsx